import './ExistingTenant.scss';
import { tenantInvitationRequestSentStateName, } from 'modules/application/tenant';
import { applicationListStateName } from 'modules/application/list';
import { ORGANIZATION_EXISTING_TENANT_REQUEST_ACCESS_BUTTON, } from '../TenantSegmentEvents';
import { logoutStateName } from 'modules/login';
export class ExistingTenantController {
    static $inject = ['$stateParams', 'TenantService', '$translate', '$state', 'BlipToastService', 'AccountService2', 'SegmentService'];
    constructor($stateParams, TenantService, $translate, $state, BlipToastService, AccountService2, SegmentService) {
        'ngInject';
        this.$stateParams = $stateParams;
        this.TenantService = TenantService;
        this.$translate = $translate;
        this.$state = $state;
        this.BlipToastService = BlipToastService;
        this.AccountService2 = AccountService2;
        this.SegmentService = SegmentService;
        this.loading = false;
        this.tenantId = this.$stateParams.id;
        this.tenantName = this.$stateParams.name;
        this.applicationListHref = this.$state.href(applicationListStateName);
    }
    getTenantUrl(tenantId, withProtocol = true) {
        return this.TenantService.getTenantUrl(tenantId, withProtocol);
    }
    async askToJoin() {
        this.loading = true;
        const user = await this.AccountService2.me();
        const emailDomain = this.AccountService2.getEmailDomain(user.email);
        await this.SegmentService.createTrack(ORGANIZATION_EXISTING_TENANT_REQUEST_ACCESS_BUTTON, {
            emailDomain: emailDomain,
            userId: user.identity,
        });
        try {
            await this.TenantService.joinTenant(this.tenantId);
            this.$state.go(tenantInvitationRequestSentStateName, {
                id: this.tenantId,
                name: this.tenantName,
            });
        }
        catch (e) {
            console.error('*** askToJoinTenant error: ', e);
            const msg = await this.$translate('existingTenant.genericError');
            this.BlipToastService.show('danger', {
                msg,
            });
        }
        finally {
            this.loading = false;
        }
    }
    async CreateAnotherAccount() {
        this.$state.go(logoutStateName);
    }
}
ExistingTenantController.$inject = ['$stateParams', 'TenantService', '$translate', '$state', 'BlipToastService', 'AccountService2', 'SegmentService'];
